import { render } from "./CarouselTiles.vue?vue&type=template&id=690fb35b&scoped=true"
import script from "./CarouselTiles.vue?vue&type=script&lang=ts"
export * from "./CarouselTiles.vue?vue&type=script&lang=ts"

import "./CarouselTiles.vue?vue&type=style&index=0&id=690fb35b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-690fb35b"

export default script